<style scoped>
  td {
    /*border: 1px solid var(--color-background);*/
  }

  div {
    /*border: 1px dotted deeppink;*/
  }

  hr {
    border: 1px solid var(--color-border);
    /*border-top: 1px double darkgray;*/
    border-top: none;
    /*color: #333;*/
    overflow: visible;
    text-align: center;
    height: 0px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .pctoffree {
    font-size: 13px;
    color: var(--color-neutral);
  }

  .clickable {
    cursor: pointer;
  }

  .bluish {
    color: var(--color-info);
  }

  .tablerow {
    background-color: var(--color-card-dark);
    height: 32px;
  }

  .oddrow {
    background-color: var(--color-card);
  }

  .firstheader {
    padding-left: 8px;
  }
  .table-header {
    padding-right: 5px;
    font-weight: bold;
    font-size: 12px;
    /*color: var(--color-text-dark);*/
  }
  .right-padding {
    padding-right: 5px;
  }
</style>

<template>
  <div>
    <AssetPanicSellModal :asset="panicSellAsset" @on-cancel="$store.state.assetPanicSellModal.show = false"/>
    <div class="box symbbox" style="margin-top: -15px; text-align: left; height: 100%">
      <Row>
<!--        <i-col span="12" style="text-align: left;">-->
<!--          <i-input size="small" clearable placeholder="поиск" style="width: 200px;" v-model="symbolSearch"-->
<!--                   @on-keydown="searchCanceled($event)" ref="searchText"></i-input>-->
<!--        </i-col>-->
<!--        <i-col span="12" style="text-align: right;">-->
<!--        </i-col>-->
        <table>
          <tr>
            <td width="220px">
              <i-input size="small" clearable :placeholder="$text.tr('поиск')" style="width: 200px;" v-model="symbolSearch"
                       @on-keydown="searchCanceled($event)" ref="searchText"></i-input>
            </td>
            <td style="width: 140px">
              <Checkbox v-model="hideZeros" size="large" style="font-size: 14px;">{{ $text.tr('СКРЫТЬ НУЛИ') }}</Checkbox>
            </td>
<!--            <td v-if="!$store.state.sys.demo">-->
<!--              <Checkbox v-model="$store.state.assets.allexchs" size="large" style="font-size: 14px;">{{ $text.tr('ВСЕ БИРЖИ') }}</Checkbox>-->
<!--            </td>-->
            <td v-if="$store.state.assets.allexchs">
              <span style="font-weight: bold; color: var(--color-warning);">{{total}}</span>
            </td>
          </tr>
        </table>
      </Row>

      <table style="margin-top: 20px; width: 100%; border-collapse: collapse;">
        <tr>
          <td v-for="(item, index) in headerItems" style="width: 15%;" class="table-header" :class="{firstheader : index === 0}" :key="'head-' + item.field">
            <div style="display: flex; align-items: center">
              <span class="clickable noselect" @click="sortList(item.field)">{{ translateAssetsHeaders(index) }}</span>
              <Icon v-if="sort.field === item.field && sort.direction === 1" type="md-arrow-dropup"/>
              <Icon v-if="sort.field === item.field && sort.direction === -1" type="md-arrow-dropdown"/>
            </div>
          </td>
          <td v-if="!$store.state.assets.allexchs && $store.state.sys.tradeExchange.ExchId !== 'BIF'" style="width: 10%" class="table-header noselect">PANIC SELL</td>
        </tr>
        <tr>
          <td style="height: 10px;" colspan="7">
            <hr>
          </td>
        </tr>
        <template v-for="(asset, index) in assetsFiltered">
          <tr :key="asset.Coin" class="tablerow" :class="{'oddrow': index % 2 === 0}">
            <td style="padding-left: 8px; padding-right: 5px;">
              <div style="display: flex;">
                <div style="vertical-align: center; padding-left: 0px; width: 24px;">
                  <CoinIcon :symbol="asset.Coin" medium />
                </div>
                <div style="padding-left: 5px; vertical-align: center;">{{ asset.Coin }}</div>
              </div>
            </td>
            <td class="bluish right-padding">{{ $store.state.sys.usdbtc === 'USD' ? '$' : ''}}{{ asset.Price[$store.state.sys.usdbtc.substr(0,1)] }}
              {{ $store.state.sys.usdbtc === 'BTC' ? 'BTC' : ''}}</td>
            <td class="right-padding">{{ asset.Total }}</td>
            <td class="right-padding">{{ asset.Free }} <span class="pctoffree" v-if="pctOfFree(asset) !== '100'">({{ pctOfFree(asset) }}%)</span></td>
            <td class="bluish right-padding">{{ terminal.usdbtcValue(asset, 'Value') }}</td>
            <td class="right-padding">{{ asset.Share }}%</td>
            <td v-if="!$store.state.assets.allexchs && $store.state.sys.tradeExchange.ExchId !== 'BIF'"><Icon v-if="!constants.isStableCoin(asset.Coin)  && !asset.Coin.includes('-')"
                      @click="showPanicSellConfirm(asset)" color="var(--color-neutral)" size="18" style="cursor: pointer;" :title="$text.tr('Продать')" type="logo-usd"></Icon>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import CoinIcon from '@/components/common/CoinIcon.vue'
import Decimal from 'decimal.js'
import terminal from '@/services/terminal'
import constants from '@/util/constants'
import AssetPanicSellModal from '../../common/AssetPanicSellModal'

export default {
  name: 'Assets',
  components: { AssetPanicSellModal, CoinIcon },
  data: function () {
    return {
      panicSellAsset: '',
      favswitch: 'all',
      symbolSearch: '',
      hideZeros: true,
      allExchs: true,
      sort: {
        direction: 1,
        field: 'coin'
      },
      headerItems: [
        {
          text: 'МОНЕТА',
          field: 'coin'
        },
        {
          text: 'ЦЕНА',
          field: 'price'
        },
        {
          text: 'КОЛ-ВО',
          field: 'qty'
        },
        {
          text: 'СВОБОДНО',
          field: 'qtyfree'
        },
        {
          text: 'СТОИМОСТЬ',
          field: 'amount'
        },
        {
          text: 'ДОЛЯ',
          field: 'share'
        }
      ]
    }
  },
  watch: {
    '$store.state.assets.allexchs' (checked) {
      // console.log(checked)
      this.$store.dispatch('updateAssets')
    }
  },
  computed: {
    total () {
      if (!this.$store.state.assets.total.U) {
        return ''
      }
      switch (this.$store.state.sys.usdbtc) {
        case 'USD':
          return '$' + this.$store.state.assets.total.U
        case 'BTC':
          return this.$store.state.assets.total.B + ' BTC'
      }
      return ''
    },
    constants () {
      return constants
    },
    terminal () {
      return terminal
    },
    assetsData () {
      if (this.$store.state.assets.allexchs) {
        return this.$store.state.assets.allexchsdata
      } else {
        return this.$store.state.assets.data
      }
    },
    assetsFiltered () {
      let list = []
      if (this.assetsData) {
        if (this.symbolSearch !== '') {
          list = this.assetsData.filter(asset => (asset.Coin.toLowerCase()).includes(this.symbolSearch.toLowerCase()))
        } else {
          this.assetsData.forEach(item => list.push(item))
        }
      }
      if (this.hideZeros) {
        list = list.filter((item) => parseFloat(item.Value.U) > 1.0)
      }

      list = list.filter((item) => item.Coin !== 'COLLATERAL')

      list.sort((a, b) => {
        let direction = 1
        switch (this.sort.field) {
          case 'coin':
            direction = a.Coin > b.Coin ? 1 : -1
            break
          case 'price':
            direction = parseFloat(a.Price.U) > parseFloat(b.Price.U) ? 1 : -1
            break
          case 'qty':
            direction = parseFloat(a.Total) > parseFloat(b.Total) ? 1 : -1
            break
          case 'qtyfree':
            direction = parseFloat(a.Free) > parseFloat(b.Free) ? 1 : -1
            break
          case 'amount':
            direction = parseFloat(a.Value.U) > parseFloat(b.Value.U) ? 1 : -1
            break
          case 'share':
            direction = parseFloat(a.Share) > parseFloat(b.Share) ? 1 : -1
            break
        }
        return this.sort.direction * direction
      })
      return list
    }
  },
  methods: {
    translateAssetsHeaders (ind) {
      return this.$text.tr(this.headerItems[ind].text)
    },
    showPanicSellConfirm (asset) {
      this.panicSellAsset = asset
      this.$store.state.assetPanicSellModal.show = true
    },
    sortList: function (field) {
      this.sort = {
        field,
        direction: -1 * this.sort.direction
      }
    },
    sum (val1, val2) {
      return new Decimal(val1).add(val2).toString()
    },
    pctOfFree (asset) {
      const res = new Decimal(asset.Free).div(asset.Total).mul(100)
      return res.toDP(1).toString()
    },
    searchCanceled (e) {
      if (e.keyCode === 27) {
        this.symbolSearch = ''
        // const elem = this.$refs.searchText
        // elem.blur()
      }
    }
    // allExchsChanged (checked) {
    //   console.log(checked)
    //   if (checked) {
    //
    //   } else {
    //
    //   }
    // }
  }
}
</script>
